'use strict';
import * as $j_app$002eprelude$002esquants$0024package$0024$0024anon$00241 from "./app.prelude.squants$package$$anon$1.js";
import * as $j_app$002eprelude$002esquants$0024package$0024$0024anon$00244 from "./app.prelude.squants$package$$anon$4.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_prelude_squants$package$() {
  this.aXW = null;
  this.aXX = false;
  this.aXY = null;
  this.aXZ = false;
  this.aY2 = null;
  this.aY3 = false;
  this.aY0 = null;
  this.aY1 = false;
}
export { $c_Lapp_prelude_squants$package$ as $c_Lapp_prelude_squants$package$ };
$p = $c_Lapp_prelude_squants$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_prelude_squants$package$;
/** @constructor */
function $h_Lapp_prelude_squants$package$() {
}
export { $h_Lapp_prelude_squants$package$ as $h_Lapp_prelude_squants$package$ };
$h_Lapp_prelude_squants$package$.prototype = $p;
$p.af5 = (function() {
  if ((!this.aXX)) {
    this.aXW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aXX = true;
  }
  return this.aXW;
});
$p.ip = (function() {
  if ((!this.aXZ)) {
    this.aXY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aXZ = true;
  }
  return this.aXY;
});
$p.bsg = (function() {
  if ((!this.aY3)) {
    this.aY2 = new $j_app$002eprelude$002esquants$0024package$0024$0024anon$00241.$c_Lapp_prelude_squants$package$$anon$1();
    this.aY3 = true;
  }
  return this.aY2;
});
$p.rv = (function() {
  if ((!this.aY1)) {
    this.aY0 = new $j_app$002eprelude$002esquants$0024package$0024$0024anon$00244.$c_Lapp_prelude_squants$package$$anon$4();
    this.aY1 = true;
  }
  return this.aY0;
});
var $d_Lapp_prelude_squants$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_prelude_squants$package$, "app.prelude.squants$package$", ({
  Ie: 1
}));
export { $d_Lapp_prelude_squants$package$ as $d_Lapp_prelude_squants$package$ };
var $n_Lapp_prelude_squants$package$;
function $m_Lapp_prelude_squants$package$() {
  if ((!$n_Lapp_prelude_squants$package$)) {
    $n_Lapp_prelude_squants$package$ = new $c_Lapp_prelude_squants$package$();
  }
  return $n_Lapp_prelude_squants$package$;
}
export { $m_Lapp_prelude_squants$package$ as $m_Lapp_prelude_squants$package$ };
//# sourceMappingURL=app.prelude.squants$package$.js.map
